import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { BreadcrumbItem, BreadcrumbState } from './types';

const initialState: BreadcrumbState = {
  breadcrumbs: []
};

const breadcrumbSlice = createSlice({
  name: 'breadcrumb',
  initialState,
  reducers: {
    setBreadcrumbs: (state, action: PayloadAction<BreadcrumbItem[]>) => {
      state.breadcrumbs = action.payload;
    },
    clearBreadcrumb: state => {
      state.breadcrumbs = [];
    },
    addBreadcrumb: (state, action: PayloadAction<BreadcrumbItem>) => {
      state.breadcrumbs.push(action.payload);
    },
    removeBreadcrumb: (state, action: PayloadAction<number>) => {
      state.breadcrumbs.splice(action.payload, 1);
    },
    updateBreadcrumb: (
      state,
      action: PayloadAction<{ index: number; breadcrumb: BreadcrumbItem }>
    ) => {
      const { index, breadcrumb } = action.payload;
      if (index >= 0 && index < state.breadcrumbs.length) {
        state.breadcrumbs[index] = breadcrumb;
      }
    }
  }
});

export const {
  setBreadcrumbs,
  clearBreadcrumb,
  addBreadcrumb,
  removeBreadcrumb,
  updateBreadcrumb
} = breadcrumbSlice.actions;

export default breadcrumbSlice.reducer;
